// extracted by mini-css-extract-plugin
export default {"mask":"ProductGalleryDialog_mask__YWHqm","dialog":"ProductGalleryDialog_dialog__EX0ha","list":"ProductGalleryDialog_list__jtjTi","item":"ProductGalleryDialog_item__KS10i"};